import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../reducers';

export const selectModel = createSelector(
  (state: RootState) => state,
  (state) => state.model
);

export default selectModel;
